import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const TitleLabel = styled.div`
  ${typographyV2.bodySm};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const SubtitleLabel = styled.div`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
